import React from "react";
import { useHistory } from "react-router-dom";
import Paper from "components/Paper";
import Text from "components/Text";
import Button from "components/Button";
import clsx from "clsx";
import Image1 from "assets/images/herohome.png";

import { ReactComponent as CalendarIcon } from "assets/icons/calendar.svg";
import styles from "./index.module.css";
const Dashboard = () => {
    const history = useHistory();
    return (
        <div className={styles.dashBoardPage}>
            <div className={styles.row}>
                <Paper className={styles.paper}>
                    <Text className="mb-12" type={"m"} align={"center"}>
                        Ai nevoie de asistență în utilizarea serviciilor Sectorului 4?
                    </Text>
                    <div
                        className={clsx(
                            styles.row,
                            styles.flexDirectoinColumn,
                            styles.alignCenter
                        )}
                    >
                        <img src={Image1} alt="image1" className="logo" />

                        <Button
                            className={styles.calendarButton}
                            size="large"
                            label="Programare pentru asistență"
                            icon={<CalendarIcon />}
                            onClick={() => history.push("/programare/step1")}
                        />
                    </div>

                    <Text type={"h2"} align={"center"} color={"secondary"}>
                        Programează-te pentru o întâlnire și colegii noștri din Biroul de
                        Asistență (localizat în Grand Arena, etajul 1) vor fi pregătiți să
                        te îndrume.
                    </Text>
                </Paper>
                <Paper className={styles.paper}>
                    <Text type={"h2"} align={"center"} color={"secondary"}>
                        Programarea este necesară pentru a beneficia de asistență personalizată pe nevoia ta. Este simplu și rapid.
                    </Text>
                </Paper>
            </div>
            <hr className={styles.line} />
            <Text type={"h5"} color={"secondary"}>
                PS4.ro prelucrează date cu caracter personal ale utilizatorilor care
                folosesc formularele de pe acest site.
            </Text>
            <Text type={"h5"} color={"secondary"}>
                Utilizatorii beneficiază de dreptul de acces la datele prelucrate, de
                intervenţie asupra acestora, de dreptul de a se opune prelucrării şi de
                a solicita ştergerea datelor şi de celelalte drepturi prevăzute de
                Regulamentul (UE) 2016/679 privind protecţia persoanelor fizice în ceea
                ce priveşte prelucrarea datelor cu caracter personal şi privind libera
                circulaţie a acestor date şi de abrogare a Directivei 95/46/CE
                (Regulamentul general privind protecţia datelor).
            </Text>
            <Text type={"h5"} color={"secondary"}>
                Site-ul start.ps4.ro foloseşte cookie-uri esențiale pentru corecta
                sa funcționare.
            </Text>
        </div>
    );
};

export default Dashboard;
